import { CustomHeaderComponent } from "../../components/custom-header/custom-header.component";
import { TenantLoaderService } from "../../tenant-association/service/tenant-loader.service";
import { TenantAssociationComponent } from "../../tenant-association/tenant-association.component";

export const TENANT_ASSOCIATION_ROUTES= [
    {
        path: 'tenant-association',
        component: TenantAssociationComponent,
        canActivate: [TenantLoaderService],
        data: {
            subComponentShow: false,
            breadcrumbComponent: CustomHeaderComponent,
            breadcrumbComponentData: {
                title: ''
            }
        },
    },
];